import { useEffect, useState } from 'react';

// assistant-ui's viewport seeds its internal "follow the bottom" flag from
// the `autoScroll` prop on first render and then scrolls to the bottom on
// every content resize while that flag is set — including the resize caused
// by the persisted transcript hydrating into an initially empty viewport.
// `scrollToBottomOnInitialize={false}` only disables a separate code path,
// so an opened thread still landed on its last message.
//
// Mounting with `autoScroll` off seeds that flag as false. Enabling it one
// frame after the transcript has rendered means the flag only turns on when
// assistant-ui itself scrolls to the bottom (a run starting, the
// scroll-to-bottom button) or when the reader scrolls there — so an opened
// thread starts at the top while streaming still follows the response.
export function useFollowStreamAfterHydration(hasMessages: boolean): boolean {
  const [followStream, setFollowStream] = useState(false);
  useEffect(() => {
    if (followStream || !hasMessages) return undefined;
    const frame = window.requestAnimationFrame(() => setFollowStream(true));
    return () => window.cancelAnimationFrame(frame);
  }, [followStream, hasMessages]);
  return followStream;
}
